var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { levelMapping } from './const';
import Chart from "./Chart";
var formateTitle = function (originalTitle) {
    var regex = /(\d+?)[.](.+)/;
    if (!regex.test(originalTitle)) {
        if (originalTitle.length > 7) {
            originalTitle = "".concat(originalTitle.slice(0, 6), "...");
        }
        return originalTitle;
    }
    var _a = __read(originalTitle.match(regex), 2), no = _a[1];
    return "\u7B2C".concat(no, "\u9898");
};
var getLevel = function (score) {
    switch (true) {
        case score >= 80:
            return 3;
        case score >= 60:
            return 2;
        default:
            return 1;
    }
};
var ReportPie = function (props) {
    var id = props.id, _a = props.source, source = _a === void 0 ? [] : _a;
    var scores = source.map(function (_a) {
        var score = _a.score;
        return score;
    });
    var isLevel = source.map(function (_a) {
        var level = _a.level;
        return level;
    }).includes(0);
    var min = Math.min.apply(Math, scores);
    var max = Math.max.apply(Math, scores);
    var data = source.map(function (_a) {
        var name = _a.name, score = _a.score, params = __rest(_a, ["name", "score"]);
        return (__assign({ name: formateTitle(name), originalName: name, value: score }, params));
    });
    var options = {
        tooltip: {
            trigger: 'item',
            formatter: function (_a) {
                var value = _a.value, _b = _a.data, rank = _b.rank, total = _b.total, originalName = _b.originalName;
                return "".concat(originalName, "<br />\u5F97\u5206\uFF1A").concat(value, "\u5206").concat(total > 0 ? "<br />\u6392\u540D\uFF1A".concat(rank, "/").concat(total) : '');
            },
            backgroundColor: 'rgba(0, 0, 0, 0.86)',
            textStyle: {
                color: '#fff',
            },
        },
        series: [
            {
                type: 'pie',
                radius: [45, 100],
                center: ['50%', '50%'],
                data: data,
                roseType: 'radius',
                label: {
                    color: 'rgba(0, 0, 0, 0.86)',
                    fontWeight: 500,
                    formatter: function (_a) {
                        var name = _a.name;
                        return "".concat(name);
                    },
                    rich: __assign({}, levelMapping),
                },
                labelLine: {
                    lineStyle: {
                        color: 'rgba(76, 175, 80, 0.3)',
                        cap: 'square',
                    },
                    length: 30,
                    length2: 30,
                },
                itemStyle: {
                    color: function (_a) {
                        var _b;
                        var level = _a.data.level;
                        return (_b = levelMapping[level]) === null || _b === void 0 ? void 0 : _b.itemColor;
                    },
                    shadowBlur: 4,
                    shadowColor: 'rgba(0, 0, 0, 0.16)',
                },
            },
            {
                type: 'pie',
                radius: [45, 100],
                center: ['50%', '50%'],
                data: data,
                roseType: 'radius',
                label: {
                    position: 'inner',
                    color: '#fff',
                    fontWeight: 500,
                    formatter: function (_a) {
                        var _b;
                        var value = _a.value, dataIndex = _a.dataIndex;
                        return "".concat(((_b = data[dataIndex]) === null || _b === void 0 ? void 0 : _b.weight.toFixed(2).replace(/\.00$/, '')) || 0, "%");
                    },
                    fontSize: 14,
                },
                itemStyle: {
                    color: function (_a) {
                        var _b;
                        var avgScore = _a.data.avgScore;
                        return (_b = levelMapping[getLevel(avgScore)]) === null || _b === void 0 ? void 0 : _b.itemColor;
                    },
                    shadowBlur: 4,
                    shadowColor: 'rgba(0, 0, 0, 0.16)',
                },
            },
        ],
    };
    return (_jsx(Chart, { id: id, options: __assign(__assign({}, options), { visualMap: isLevel
                ? {
                    show: false,
                    min: min,
                    max: max,
                    inRange: {
                        color: [
                            'rgba(0, 217, 157, 0.2)',
                            'rgba(0, 217, 157, 0.4)',
                            'rgba(0, 217, 157, 0.6)',
                            'rgba(0, 217, 157, 0.8)',
                            'rgba(0, 217, 157, 1)',
                        ],
                    },
                }
                : null }) }));
};
export default ReportPie;
